import React from "react";
import { Box, Typography, LinearProgress, Chip, Stack } from "@mui/material";
import { LocalFireDepartment as FlameIcon } from "@mui/icons-material";
import { BRAND_COLORS, brandRgba } from "../../utils/brandAssets";
import { getXpProgress } from "../../utils/triviaArcade";

const TriviaProgressRail = ({ userStats }) => {
  if (!userStats) return null;

  const xp = getXpProgress(userStats.totalExperiencePoints || 0);
  const accuracy = Math.round((userStats.overallAccuracy || 0) * 100);

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
        mb: 3,
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 1.5 }}>
        <Chip
          label={`Level ${xp.level}`}
          sx={{
            bgcolor: BRAND_COLORS.cyan,
            color: BRAND_COLORS.navy,
            fontWeight: 700,
          }}
        />
        <Box sx={{ flex: 1 }}>
          <LinearProgress
            variant="determinate"
            value={xp.percent}
            sx={{
              height: 8,
              borderRadius: 999,
              bgcolor: brandRgba(BRAND_COLORS.cyan, 0.16),
              "& .MuiLinearProgress-bar": {
                backgroundColor: BRAND_COLORS.cyan,
                borderRadius: 999,
              },
            }}
          />
        </Box>
        <Typography variant="caption" color="text.secondary">
          {xp.xpIntoLevel}/{xp.xpPerLevel} XP
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        <Chip
          icon={<FlameIcon />}
          label={`Streak ${userStats.currentStreak || 0}`}
          size="small"
        />
        <Chip label={`Best ${userStats.bestScore || 0}`} size="small" />
        <Chip label={`${accuracy}% accuracy`} size="small" />
      </Stack>
    </Box>
  );
};

export default TriviaProgressRail;
